//#region imports
import { Component, OnInit } from '@angular/core';
import { SignatureService } from 'src/app/services/signature.service';
import { SimulationReservationReason } from 'src/app/module/recapitulatory/model/recapitulatory.model';
import { AppConstants } from 'src/app/app.constants';
import { Signature4Answers, SaveCriteriaModel } from '../../model/signature.model';
import { P5xService } from 'src/app/services/p5x.service';
import { SectionService } from 'src/app/services/section.service';
import { Globals } from 'src/app/services/globals';
import { NotificationService } from 'src/app/services/notification.service';
import { TranslateService } from '@ngx-translate/core';
//#endregion

@Component({
  selector: 'app-signature-question4',
  templateUrl: './signature-question4.component.html',
  styleUrls: ['./signature-question4.component.css']
})
export class SignatureQuestion4Component implements OnInit {
  //#region variables
  cb1Checked = false;
  cb2Checked = false;
  cb3Checked = false;
  cb4Checked = false;
  txtRequirements = '';
  //#endregion

  //#region methods
  constructor(
    private signatureService: SignatureService, private p5xService: P5xService,
    private sectionService: SectionService, private global: Globals,
    private notification: NotificationService, private translate: TranslateService) { }

  ngOnInit() {
    this.sectionService.setCurrentPage('P5-4');
    this.global.trackPageActivity += ';' + 'P5-4';
    this.signatureService.setShowSignaturePrevious(true);
    const answers = this.signatureService.getSignature4Answers();
    if (answers !== undefined) {
      this.cb1Checked = answers.FirstCheckbox, this.cb2Checked = answers.SecondCheckbox,
        this.cb3Checked = answers.ThirdCheckbox, this.cb4Checked = answers.FourthCheckbox,
        this.txtRequirements = answers.RequirementText;
    } else {
      const signature4Answers: Signature4Answers = {
        FirstCheckbox: this.cb1Checked, SecondCheckbox: this.cb2Checked, ThirdCheckbox: this.cb3Checked,
        FourthCheckbox: this.cb4Checked, RequirementText: this.txtRequirements
      };
      this.signatureService.setSignature4Answers(signature4Answers);
    }
    const saveCriteria: SaveCriteriaModel = {
      Criteria_sinistrality: this.cb1Checked,
      Criteria_cancellation_other_company: this.cb2Checked,
      Criteria_never_insured_property: this.cb3Checked,
      Criteria_bankrupty: this.cb4Checked,
      Taker_specific_requirement: this.txtRequirements ? this.txtRequirements : '',
      Sales_office: null,
      ID_IMD: null,
      Longitude: null,
      Lattidude: null,
      FNICEFile: null,
      NoClient: null,
      OfferDocPath: null
    };
    this.signatureService.setSaveCriteria(saveCriteria);
  }

  onChange1($event) {
    if ($event.target.checked) {
      this.cb1Checked = true;
    } else {
      this.cb1Checked = false;
    }
    this.p5XAcceptanceCriteria();
  }

  onChange2($event) {
    if ($event.target.checked) {
      this.cb2Checked = true;
    } else {
      this.cb2Checked = false;
    }
    this.p5XAcceptanceCriteria();
  }

  onChange3($event) {
    if ($event.target.checked) {
      this.cb3Checked = true;
    } else {
      this.cb3Checked = false;
    }
    this.p5XAcceptanceCriteria();
  }

  onChange4($event) {
    if ($event.target.checked) {
      this.cb4Checked = true;
    } else {
      this.cb4Checked = false;
    }
    this.p5XAcceptanceCriteria();
  }

  p5XAcceptanceCriteria() {
    const signature4Answers: Signature4Answers = {
      FirstCheckbox: this.cb1Checked, SecondCheckbox: this.cb2Checked, ThirdCheckbox: this.cb3Checked,
      FourthCheckbox: this.cb4Checked, RequirementText: this.txtRequirements
    };
    this.setSaveCriteria();
    this.signatureService.setSignature4Answers(signature4Answers);
    if (this.cb1Checked || this.cb2Checked || this.cb3Checked || this.cb4Checked) {
      const simulationReservationReason: SimulationReservationReason = {
        ID: AppConstants.SimulationReservationReason.AcceptanceCriteria.ID,
        Text: AppConstants.SimulationReservationReason.AcceptanceCriteria.Text
      };
      this.p5xService.setSimulationReservationReason(simulationReservationReason);
      this.signatureService.setAcceptanceCriteria(true);
    } else {
      this.signatureService.setAcceptanceCriteria(false);
    }
  }

  onChange5() {
    if (this.txtRequirements.length > 0) {
      this.signatureService.setP5XTxtBoxRequirement(true);
    } else {
      this.signatureService.setP5XTxtBoxRequirement(false);
    }
    const signature4Answers: Signature4Answers = {
      FirstCheckbox: this.cb1Checked, SecondCheckbox: this.cb2Checked, ThirdCheckbox: this.cb3Checked,
      FourthCheckbox: this.cb4Checked, RequirementText: this.txtRequirements
    };
    this.signatureService.setSignature4Answers(signature4Answers);
    this.setSaveCriteria();
  }

  setSaveCriteria() {
    const saveCriteria = this.signatureService.getSaveCriteria();
    saveCriteria.Criteria_sinistrality = this.cb1Checked;
    saveCriteria.Criteria_cancellation_other_company = this.cb2Checked;
    saveCriteria.Criteria_never_insured_property = this.cb3Checked;
    saveCriteria.Criteria_bankrupty = this.cb4Checked;
    saveCriteria.Taker_specific_requirement = this.txtRequirements;
    saveCriteria.Sales_office = null;
    saveCriteria.Longitude = null;
    saveCriteria.Lattidude = null;
    saveCriteria.FNICEFile = null;
    saveCriteria.NoClient = null;
    saveCriteria.OfferDocPath = null;
    this.signatureService.setSaveCriteria(saveCriteria);
  }
  helpDialog(value: string) {
    value = this.translate.instant(value);
    this.notification.openDialog(value);
  }
  //#endregion
}
